<template>
    <div>
<!--        <strong>{{ $_.get(activity, "actorUser.name") }}</strong>-->
<!--        added a new contact property-->
<!--        "<strong>{{ $_.get(activity, "payload.name") }}</strong>"-->
        <span v-html="$t('notification.contactPropAdded', {user: $_.get(activity, 'actorUser.name'), prop: $_.get(activity, 'payload.name') })"></span>
    </div>
</template>
<script>
import Vue from "vue";

export default Vue.extend({
    name: "ContactPropAdded",
    props: {
        activity: {
            type: Object,
            default: () => ({}),
        },
    },
});
</script>

<style scoped lang="scss"></style>
